export const ArchieTheme = {
  typography: {
    fontFamily: "Raleway, Sans Serif",
  },
  overrides: {
    MuiButton: {
      root: {
        color: "inherit",
        "&:hover": {
          backgroundColor: "transparent"
        },
      }
    },
    MuiListItem: {
      root: {
        flexWrap: "wrap",
        paddingTop: 0,
        paddingBottom: 0,
        "&:hover": {
          backgroundColor: "transparent"
        },
      },
      gutters: {
        paddingLeft: 0,
        paddingRight: 0,
      }
    },
    MuiListItemIcon: {
      root: {
        color: "#01bfd8",
        fontSize: 24
      },
    },
    MuiListItemText: {
      root: {
        //color: "#fff",
        textAlign: "left",
      }
    },
    MuiToolbar: {
      root: {
        maxWidth: 960,
        justifyContent: "space-between",
      },
    }
  }
}

export default ArchieTheme
